

import React from 'react';
import { 
  Paper,
  Grid,
  useTheme
} from '@mui/material';
import { 
  Settings,
  Tag,
  Badge,
  ConfirmationNumber,
  SimCard,
  Speed,
  CalendarToday
} from '@mui/icons-material';
import ParameterItem from './ParameterItem';
import SectionHeader from './SectionHeader';
import { useAuth } from '../../../AuthContext';

const DeviceInformation = ({ sx }) => {
  const { pumpStats } = useAuth();
  const theme = useTheme();
  
  if (!pumpStats?.pump_info) return null;
//console.log('this device information section ran again')
  return (
    <Paper sx={{ 
      borderRadius: theme.shape.borderRadius * 2,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      ...sx
    }}>
      <SectionHeader icon={<Settings fontSize="small" />} title="Device Information" />
      
      <Grid container spacing={1} sx={{ 
        p: 2,
        flex: 1,
        rowGap:3,
        columnGap:0,
        
        alignContent: 'flex-start'
      }}>
        <ParameterItem 
          icon={<Tag />} 
          name="Pump Name" 
          value={pumpStats.pump_info.name} 
        />
         <ParameterItem 
          icon={<Tag />} 
          name="Consumer" 
          value={pumpStats?.consumer_name} 
        />
        <ParameterItem 
          icon={<Tag />} 
          name="Mobile Number" 
          value={pumpStats?.consumer_mobile} 
        />
      
        <ParameterItem 
          icon={<Badge />} 
          name="Model" 
          value={pumpStats?.pump_info.model_number  } 
        />
         <ParameterItem 
          icon={<Badge />} 
          name="Make" 
          value={pumpStats?.pump_info.manufacturer  } 
        />
        <ParameterItem 
          icon={<ConfirmationNumber />} 
          name="Serial No" 
          value={pumpStats.pump_info.serial_number} 
        />
        <ParameterItem 
          icon={<SimCard />} 
          name="SIM ICCID" 
          value={pumpStats.pump_info.sim_iccid} 
        />
        <ParameterItem 
          icon={<SimCard />} 
          name="IMEI" 
          value={pumpStats.pump_info.imei} 
         
        />
        <ParameterItem 
          icon={<Speed />} 
          name="Rating" 
          value={pumpStats.pump_info.rating} 
          unit={'HP'}
        />
        <ParameterItem 
          icon={<Speed />} 
          name="Controller Number" 
          value={pumpStats.pump_info.controller_number} 
          
        />
        <ParameterItem 
          icon={<Speed />} 
          name="Panel Number" 
          value={pumpStats.pump_info?.panel_number_list?.join(', ') } 
        
        />
        <ParameterItem 
          icon={<CalendarToday />} 
          name="Created" 
          value={new Date(pumpStats.pump_info.created_date).toLocaleDateString()} 
        />
      </Grid>
    </Paper>
  );
};

export default React.memo(DeviceInformation);
